<template>
  <div class="card">
    <div class="card-header">
      <span class="card-header-title">Sign in</span>
    </div>

    <div class="card-content">
      <form @submit.stop.prevent="login()">
        <BForm
          :elements="form"
          mode="lazy"
          @valid="form.valid = $event"
          @submit="login()"
        ></BForm>

        <section class="footer-container">
          <button
            :class="{ 'is-loading': isLoading || !ready }"
            :disabled="
              isLoading || !hasEmailAndPassword || !form.valid || !ready
            "
            class="button is-primary"
            type="submit"
          >
            Sign in
          </button>
        </section>
      </form>

      <section v-if="ready" class="buttons-section">
        <button
          v-if="
            $store.state.settings.server &&
              $store.state.settings.server.resetPasswordEnabled
          "
          type="button"
          class="simple-button"
          @click="$emit('action', 'reset')"
        >
          Reset password
        </button>

        <button
          v-if="
            $store.state.settings.server &&
              $store.state.settings.server.publicSignupEnabled
          "
          type="button"
          class="simple-button is-fullwidth"
          @click="$emit('action', 'signup')"
        >
          Sign up
        </button>
      </section>
    </div>
  </div>
</template>

<script>
import BForm from "@/components/singles/BForm/component.vue";
import { setAuth, reroute } from "@/utils/auth";
import { loadSettings } from "@/utils/app";

import fp from "@/utils/fingerprint";

export default {
  components: {
    BForm,
  },
  props: { value: Boolean, email: String },
  data() {
    return {
      isLoading: false,
      fingerprint: null,
      form: {
        valid: false,
        inputs: [
          {
            focus: true,
            icon: "mdi-email",
            name: "username",
            placeholder: "Email",
            type: "email",
            validation: "",
            value: this.email || "",
          },
          {
            icon: "mdi-lock",
            name: "password",
            placeholder: "Password",
            type: "password",
            validation: "",
            value: "",
          },
        ],
      },
    };
  },
  computed: {
    hasEmailAndPassword() {
      return this.form.inputs.every((x) => x.value);
    },

    ready() {
      return this.$store.state.settings.server && this.fingerprint;
    },
  },
  async mounted() {
    this.isLoading = true;

    this.$nextTick(async () => {
      this.fingerprint = await fp.get(true);
    });

    if (this.$store.state.auth.success) {
      reroute();
    }
    this.isLoading = false;
  },
  methods: {
    async login() {
      if (!this.form.valid || !this.hasEmailAndPassword) {
        return;
      }

      this.isLoading = true;

      try {
        const res = await this.$helpers.postApi(
          "login",
          {
            username: this.form.inputs[0].value.toLowerCase().trim(),
            password: this.form.inputs[1].value,
            fp: this.fingerprint,
          },
          { skipDataObject: true, skipAuth: true, fullDataObject: true }
        );

        if (res.status === 201) {
          this.$emit("complete", {
            ...res.data,
            fingerprint: this.fingerprint,
            mail: this.form.inputs[0].value.toLowerCase(),
          });
          this.$emit("action", "twoFa");
        } else this.loginSuccessful(res.data);
      } catch (err) {
        this.loginError(err);
      }
    },

    async loginSuccessful(user) {
      try {
        setAuth(user);

        this.$helpers.notify(`<span>Welcome!</span>`, "", "success");
        await loadSettings();
        reroute();
        this.isLoading = false;
      } catch (err) {
        console.error(err);
      }
    },

    loginError(err) {
      if (err.response && err.response.data) {
        const data = err.response.data;

        this.isLoading = false;

        this.form.inputs[1].value = "";
        this.form.inputs[1].valid = false;

        if (data.countLeft) {
          this.$helpers.notify(
            "Incorrect email or password",
            `${data.countLeft} more ${
              data.countLeft > 1 ? "tries" : "try"
            }  until locked out.`,
            "warning"
          );
        } else {
          this.$helpers.notify(
            "Locked out",
            `You have to reset your password to be able to sign in again.`,
            "danger",
            -1
          );
        }
      }
    },
  },
};
</script>
